<ng-container *transloco="let t;">
  <div class="card">

    <div class="p-grid">
      <div class="p-col-12">
        <h1>{{ t('dashboard.topline') }}</h1>
        <p *ngIf="name !== null" [innerHTML]="t('dashboard.welcome', { name })"></p>
      </div>
    </div>

    <div class="p-grid p-mt-4">
      <div class="p-col-3" *ngFor="let tile of tiles">
        <a [routerLink]="tile.routerLink">
          <p-card>
            <div class="p-text-center">
              <p><i [ngClass]="tile.icon"></i></p>
              <h2>{{ t('menu.' + tile.label) }}</h2>
            </div>
          </p-card>
        </a>
      </div>
    </div>

  </div>
</ng-container>
